import { render, staticRenderFns } from "./ResultsTov.vue?vue&type=template&id=19d21d9d&"
import script from "./ResultsTov.vue?vue&type=script&lang=js&"
export * from "./ResultsTov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports